import script from "./TopLeagesMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./TopLeagesMobile.vue?vue&type=script&setup=true&lang=js"

import "./TopLeagesMobile.vue?vue&type=style&index=0&id=e2826fa8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2826fa8"]])

export default __exports__